/** Help content ("How it works") for each condition and action type */

export const CONDITION_HELP_CONTENT: Record<string, { title: string; body: string }> = {
    keywords: {
        title: "Keyword",
        body: "Messages containing the keywords you add will trigger this workflow. Use uppercase for consistency. You can choose whether the message must start with the keyword or contain it anywhere.",
    },
    numbers: {
        title: "From Number",
        body: "Limit this workflow to messages from selected phone numbers. Only messages from numbers you choose will trigger the flow.",
    },
    countries: {
        title: "Countries",
        body: "Limit this workflow to messages from selected countries. Use this to run flows only for contacts in specific regions.",
    },
    schedule: {
        title: "Run Schedule",
        body: "Control when this workflow runs based on time. Choose 24/7, business hours, outside business hours, or set a custom schedule.",
    },
    other: {
        title: "Condition",
        body: "Configure when this workflow step should continue based on your selected condition type.",
    },
};

export const ACTION_HELP_CONTENT: Record<string, { title: string; body: string }> = {
    AutomatedResponse: {
        title: "Automated Response",
        body: "Send an automatic reply when the condition is met. You can use a template or compose a custom message. Optionally apply once per contact.",
    },
    NotifyUser: {
        title: "Notify User",
        body: "Send an email notification to record owner, account owner, or custom addresses when the condition is met.",
    },
    CreateLead: {
        title: "Create Lead",
        body: "Automatically create a new lead in your CRM when a message or call is received from a number that isn't linked to any existing contact or lead.",
    },
    AddNote: {
        title: "Add Note",
        body: "Control how inbound and outbound messages are logged in your CRM. Choose whether to merge activities into a single note and where to log received messages.",
    },
    LogActivity: {
        title: "Log Activity",
        body: "Control how inbound and outbound messages are logged in your CRM. Choose whether to merge activities into a single activity as notes and where to log received messages. For outbound, choose to log on send or on delivery.",
    },
    Delay: {
        title: "Delay",
        body: "Pause the workflow for a specified time before continuing to the next step. Delay must be between 15 minutes and 30 days.",
    },
    default: {
        title: "Action",
        body: "Configure what happens when the condition is met.",
    },
};
